<div class="title">
  <h2 class="headline-5">{{ titleKey | translate }}</h2>
  <ng-container *dapLibHideForBreakpoint="'for-XSmall-Down'">
    <ng-container *ngTemplateOutlet="dots"></ng-container>
  </ng-container>
</div>

<div #carouselRef class="carousel">
  <div class="container">
    <ng-content></ng-content>
  </div>
</div>

<ng-container *dapLibShowForBreakpoint="'for-XSmall-Down'">
  <ng-container *ngTemplateOutlet="dots"></ng-container>
</ng-container>

<ng-template #dots>
  <div *ngIf="slideSelectionStates" class="dots">
    <button
      *ngFor="let selected of slideSelectionStates; let index = index"
      (click)="onDotClick(index)"
      [class]="{ dot: true, selected: selected }"
      type="button"
    ></button>
  </div>
</ng-template>
